import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MemedService {
	serviceUrl = environment.servicesUrl;

	constructor(private httpClient: HttpClient) {}

	public getToken(): Observable<{ token: string }> {
		return this.httpClient.get<{ token: string }>(
			`${this.serviceUrl}/promptuary/v1/memed/user/token`
		);
	}

	createUser() {
		return this.httpClient.post<any>(
			`${this.serviceUrl}/promptuary/v1/memed/user`,
			{}
		);
	}

	registerDocumentPrescription(data: {
		prescriptionId: string;
		customerId: string;
		eventId: string;
	}) {
		return this.httpClient.post<{ registered: boolean }>(
			`${this.serviceUrl}/promptuary/v1/memed/prescription`,
			data
		);
	}
}
